import { Controller } from "@hotwired/stimulus"
import { createTurboDataTable, destroyTurboDataTable } from "lib/datatables_turbo"

// content/picker.haml  data-controller="content--picker"
export default class extends Controller {
  static targets = ["table"]

  static values = {
    pickerPath: String,
    selectedInputSelector: { type: String, default: "#advanced_send_rich_push" },
  }

  connect() {
    if (!this.hasTableTarget) return

    $.fn.dataTable.ext.errMode = function (_settings, _helpPage, message) {
      alert("Internal server error")
      console.error(message)
    }

    this.#initDataTable()
  }

  disconnect() {
    if (this.dataTable) {
      this.dataTable = destroyTurboDataTable(this.dataTable)
    }
  }

  addSelected(event) {
    event.preventDefault()

    const availableCheckboxes = this.tableTarget.querySelectorAll("input[type='checkbox']")
    const checkedIds = Array.from(availableCheckboxes)
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value)

    if (availableCheckboxes.length === 0) return

    if (checkedIds.length === 0) {
      alert("Please select at least one item")
      return
    }

    const selectedInput = document.querySelector(this.selectedInputSelectorValue)
    if (selectedInput) selectedInput.value = checkedIds.join(",")

    $("#content-picker-dialog").modal("hide")
  }

  showPhoto(event) {
    event.preventDefault()

    const { previewUrl } = event.currentTarget.dataset
    $.getJSON(previewUrl, (response) => {
      if (!response.url) return

      $("#image-preview").attr("src", response.url)
      $("#image-modal").modal("show")
    })
  }

  showText(event) {
    event.preventDefault()

    const link = event.currentTarget
    $.getJSON(link.dataset.previewUrl, (response) => {
      if (response.url) link.href = response.url
      link.removeAttribute("data-action")
      $(link).fancybox({ type: "iframe" })
      link.click()
    })
  }

  #initDataTable() {
    this.dataTable = createTurboDataTable(this.tableTarget, {
      dom: 'lrftip<"toolbar">',
      pagingType: "full_numbers",
      processing: true,
      serverSide: true,
      stateSave: false,
      ajax: {
        url: this.pickerPathValue,
      },
      stateLoadParams(_settings, data) {
        data.search.search = ""
      },
      footerCallback() {
        $("#check-all").attr("checked", false)
      },
      columnDefs: [
        {
          targets: 0,
          createdCell(cell, cellData) {
            $(cell).html(
              `<input type="checkbox" class="table-checkbox" id="check--picker${cellData}" name="item_ids[]" value="${cellData}"/> <label for="check--picker${cellData}"><label/>`,
            )
          },
        },
        {
          targets: 5,
          createdCell(cell, cellData, rowData) {
            const data = cellData.split(" ")
            if (rowData[3].substring(13, 19) === "image/") {
              $(cell).html(
                `<a class="view-photo" id="photo${data[0]}" href="#" data-action="click->content--picker#showPhoto" data-preview-url="${data[1]}"><span>View</span></a>`,
              )
            } else {
              $(cell).html("<span>No preview</span>")
            }
          },
        },
        {
          targets: [0, 5],
          sortable: false,
        },
      ],
    })

    if (this.hasTableTarget) {
      $(this.element).find("div.toolbar")
        .addClass("rich")
        .html('<br><br><a href="#" class="btn-add" data-action="click->content--picker#addSelected">Add selected</a>')
    }
  }
}
